import { createContext, ReactNode, useContext } from 'react';

import { LookupType } from '@work4all/models/lib/Enums/LookupType.enum';

interface LookUpContextType {
  lookupType: LookupType;
}

const LookUpContext = createContext<LookUpContextType | undefined>(undefined);

interface LookUpProviderProps {
  lookupType: LookupType;
  children: ReactNode;
}

export const LookUpProvider = ({
  lookupType,
  children,
}: LookUpProviderProps) => {
  return (
    <LookUpContext.Provider value={{ lookupType }}>
      {children}
    </LookUpContext.Provider>
  );
};

export const useLookUpContext = () => {
  const context = useContext(LookUpContext);
  if (context === undefined) {
    throw new Error('useLookUpContext must be used within a LookUpProvider');
  }
  return context;
};
